export {
  MissingFieldAnchor,
  MissingFieldHighlightProvider,
  useHighlightedMissingTarget,
} from './missing-field-anchor';
export {
  incompleteProfileSectionIds,
  isEducationFinished,
  isProfileFieldMissing,
  missingEducationTargetId,
  type MissingFieldDef,
  type MissingFieldKey,
  missingFieldTargetId,
  missingProfileFieldCount,
  missingProjectTargetId,
  PROFILE_FIELD_ORDER,
} from './missing-fields.constants';
export {
  type ProfileMissingFieldsResult,
  useProfileMissingFields,
} from './use-profile-missing-fields';
